import React, { useContext, useMemo } from "react";
import { BBVAFinancing } from "./BBVAFinancing/web";
import { ItauFinancing } from "./ItauFinancing/web";
import { ConfigStateContext } from "../../Contexts/Configurations/context";
import { isRent, isSell } from "../../Utils/Functions";
import { MapfreFinancing } from "./MapfreFinancing/web";
import { ItauFinancingV2 } from "./ItauFinancingV2/ItauFinancingV2";
import { SancorGuarantee } from "./SancorGuarantee/web";
import "./styles.less";

const PROPERTY_TYPE_NOT_TO_BE_DISPLAYED = 3;
const MIN_PROPERTY_PRICE = 37000;

const IsPriceToConsult = price =>
	!price?.currency || !price || price.amount == 0 || (price?.isTemp && price?.amount < 5);

export const Financing = ({
	operationType,
	id,
	propertyType,
	propertyPrice,
	isDisabledProperty = false,
	reference = "",
	financingRef = null,
	showFinancingCard = false,
}) => {
	const { country_code } = useContext(ConfigStateContext);

	return (
		<>
			{isSell(operationType) &&
			country_code == "UY" &&
			propertyPrice &&
			propertyPrice.amount &&
			propertyType &&
			propertyType != PROPERTY_TYPE_NOT_TO_BE_DISPLAYED &&
			propertyPrice.amount >= MIN_PROPERTY_PRICE &&
			!propertyPrice.hidePrice &&
			!IsPriceToConsult(propertyPrice) ? (
				<ItauFinancingV2
					id={id}
					isDisabledProperty={isDisabledProperty}
					showFinancingCard={showFinancingCard}
					financingRef={financingRef}
				/>
			) : null}
			{isRent(operationType) &&
			country_code == "UY" &&
			propertyPrice &&
			propertyPrice.amount &&
			!propertyPrice.hidePrice &&
			!IsPriceToConsult(propertyPrice) ? (
				<MapfreFinancing
					id={id}
					propertyType={propertyType}
					propertyPrice={propertyPrice}
					isDisabledProperty={isDisabledProperty}
					showFinancingCard={showFinancingCard}
					financingRef={financingRef}
				/>
			) : null}
			{isSell(operationType) && country_code == "PY" && (
				<ItauFinancing
					id={id}
					isDisabledProperty={isDisabledProperty}
					showFinancingCard={showFinancingCard}
					financingRef={financingRef}
				/>
			)}
			{/*
			 * Garantía de alquiler de Sancor Seguros (INF-603). Va en los dos slots, igual
			 * que Mapfre: el widget entero en la columna principal y la tira con el botón
			 * «Calcular» en el sidebar de desktop. Cuál de los dos se dibuja lo elige el
			 * componente por `showFinancingCard`, y las reglas de elegibilidad que dependen
			 * del precio también son suyas.
			 */}
			{isRent(operationType) && country_code == "PY" && (
				<SancorGuarantee
					id={id}
					price={propertyPrice}
					isDisabledProperty={isDisabledProperty}
					showFinancingCard={showFinancingCard}
					financingRef={financingRef}
				/>
			)}
		</>
	);
};

